/**
 * Validation utilities for use across the application
 */

/**
 * Matches international phone numbers in E.164 format:
 * - Must start with +
 * - Followed by 1-4 digits (country code)
 * - Followed by 1-14 digits (phone number)
 * - Optionally followed by # and 1-6 digits (extension)
 */
export const phoneRegExp = /^\+[0-9]{1,4}[0-9]{1,14}(#[0-9]{1,6})?$/;
